package com.milta.feature.route.domain.usecase

import com.milta.feature.route.domain.entity.DeliveryOutcome
import com.milta.feature.route.domain.entity.DeliveryProof
import com.milta.feature.route.domain.repository.RouteRepository

/** POST /api/v1/routes/{routeId}/deliveries/{deliveryId}/validate (MIL-41 — écran "Preuve de livraison"). */
class ValidateDeliveryUseCase(private val repository: RouteRepository) {
    suspend operator fun invoke(
        routeId: String,
        deliveryId: String,
        photoBytes: ByteArray,
        photoFileName: String,
        status: DeliveryOutcome,
        comment: String?,
    ): DeliveryProof = repository.validateDelivery(routeId, deliveryId, photoBytes, photoFileName, status, comment)
}
